"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const rc_progress_1 = require("rc-progress");
const Box_1 = __importDefault(require("@mui/material/Box"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const TxnPageFooter = (props) => {
    const { theme } = props;
    const metrics = props.transactionListMetrics;
    const txnReviewedPercentage = ((metrics.reviewedCount + 1) / (metrics.numTxns + 1)) * 100;
    let gradeText;
    let strokeColor;
    switch (true) {
        case txnReviewedPercentage < 25:
            gradeText = 'You have some work to do';
            strokeColor = theme.palette.personalDark;
            break;
        case txnReviewedPercentage < 50:
            gradeText = 'You are making good progress';
            strokeColor = theme.palette.caringDark;
            break;
        case txnReviewedPercentage < 75:
            gradeText = 'Over halfway there, keep reviewing!';
            strokeColor = theme.palette.optimisticDark;
            break;
        case txnReviewedPercentage < 100:
            gradeText = 'Just about reviewed them all, bring it home!';
            strokeColor = theme.palette.success.light;
            break;
        case txnReviewedPercentage >= 100:
            gradeText = 'All transactions reviewed, great work!';
            strokeColor = theme.palette.positiveDark;
            break;
        default:
            gradeText = 'Error';
            strokeColor = theme.palette.groundedDark;
    }
    if (props.hideFooter) {
        return (<Box_1.default height={2} overflow="hidden" ref={props.footerRef}/>);
    }
    return (<div className={props.classes.txFooter} ref={props.footerRef}>
      {!props.hideSearch && metrics.numTxns > 0 && (<QTip_1.default title={`Transactions marked reviewed, (${metrics.reviewedCount}/${metrics.numTxns}) ${gradeText}`}>
          <rc_progress_1.Line className={props.classes.progressBar} percent={txnReviewedPercentage} strokeWidth={2} trailWidth={2} strokeColor={strokeColor}/>
        </QTip_1.default>)}
    </div>);
};
exports.default = TxnPageFooter;
